<template>
<div>
  <h1>{{$t('rotation-panel')}}</h1>
  <div class="actions level">
    <button class="button is-small level-item" @click="degreesRotation = 0">{{ $t('button-reset') }}</button>
    <button class="button is-small level-item" @click="increment(90)">+90°</button>
    <button class="button is-small level-item" @click="increment(-90)">-90°</button>
  </div>
  <cytomine-slider v-model="degreesRotation" :max="360" :integerOnly="false" :lazy="false" />
</div>
</template>

<script>
import CytomineSlider from '@/components/form/CytomineSlider';

export default {
  name: 'rotation-panel',
  components: {CytomineSlider},
  props: {
    index: String
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    viewerModule() {
      return this.$store.getters['currentProject/currentViewerModule'];
    },
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    rotation() {
      return this.imageWrapper.view.rotation;
    },
    degreesRotation: {
      get() {
        return Math.round(this.rotation * 180 / Math.PI * 1000) / 1000;
      },
      set(value) {
        console.log('panel, set rotation', value);
        const newRotation = Number(value) / 180 * Math.PI;
  
        // 1. 현재 뷰어 슬롯의 회전값 변경 (실제 화면 회전)
        this.$store.dispatch(this.viewerModule + 'setRotation', {
          index: this.index,
          rotation: newRotation
        });
      }
    }
  },
  methods: {
    increment(inc) {
      this.degreesRotation = (this.degreesRotation + inc + 360) % 360;
    }
  }
};
</script>
